var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBentoMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    width: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "Tools"), /*#__PURE__*/React.createElement("g", {
    id: "Bento-Menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-1",
    fill: "currentColor",
    x: 16,
    y: 4,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-2",
    fill: "currentColor",
    x: 10,
    y: 4,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-3",
    fill: "currentColor",
    x: 16,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-4",
    fill: "currentColor",
    x: 10,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-5",
    fill: "currentColor",
    x: 16,
    y: 16,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-6",
    fill: "currentColor",
    x: 10,
    y: 16,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-7",
    fill: "currentColor",
    x: 4,
    y: 4,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-8",
    fill: "currentColor",
    x: 4,
    y: 10,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "shape-9",
    fill: "currentColor",
    x: 4,
    y: 16,
    width: 4,
    height: 4,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentoMenu);
export default __webpack_public_path__ + "static/media/bento-menu.11968b03d8b27e7d3565265365037597.svg";
export { ForwardRef as ReactComponent };